export default __webpack_public_path__ + "static/about-3-5291fde9663e05390457cc3b88510978.webp";